/* Geometry only: no replacement of native details, focus, cart or search handlers. */
(() => {
  if (window.glgsNavigationGeometry) { window.glgsNavigationGeometry.init(); return; }
  const controllers = new WeakMap();
  const init = (root = document) => {
    root.querySelectorAll('[data-glgs-navigation]').forEach((wrapper) => {
      if (controllers.has(wrapper)) return;
      const section = wrapper.closest('.shopify-section');
      const drawer = wrapper.querySelector('#menu-drawer');
      const rootDetails = wrapper.querySelector('#Details-menu-drawer-container');
      const abort = new AbortController();
      let frame = 0;
      let trackUntil = 0;
      const measure = () => {
        const viewport = window.visualViewport;
        const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        // Mega panels anchor to the wrapper bottom; ignore their animated translateY.
        wrapper.style.setProperty('--glgs-panel-height', Math.max(0, bottom - wrapper.getBoundingClientRect().bottom - 12) + 'px');
        if (drawer && rootDetails && rootDetails.open) {
          wrapper.style.setProperty('--glgs-drawer-height', Math.max(0, bottom - drawer.getBoundingClientRect().top) + 'px');
        }
      };
      const tick = () => {
        frame = 0;
        measure();
        if (performance.now() < trackUntil) frame = requestAnimationFrame(tick);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(tick); };
      const track = () => { trackUntil = performance.now() + 400; schedule(); };
      const listen = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal: abort.signal });
      listen(wrapper, 'toggle', track, { capture: true });
      const isStickyTop = (event) => event.target === section && event.propertyName === 'top';
      listen(section, 'transitionrun', (event) => { if (isStickyTop(event)) track(); });
      listen(section, 'transitionend', (event) => { if (isStickyTop(event)) schedule(); });
      listen(section, 'transitioncancel', (event) => { if (isStickyTop(event)) schedule(); });
      listen(window, 'scroll', schedule, { passive: true });
      listen(window, 'resize', track, { passive: true });
      listen(window.visualViewport, 'resize', track, { passive: true });
      listen(window.visualViewport, 'scroll', schedule, { passive: true });
      const sizeObserver = new ResizeObserver(schedule);
      sizeObserver.observe(wrapper);
      const classObserver = new MutationObserver(track);
      if (section) classObserver.observe(section, { attributes: true, attributeFilter: ['class'] });
      const destroy = () => {
        abort.abort();
        sizeObserver.disconnect();
        classObserver.disconnect();
        cancelAnimationFrame(frame);
        controllers.delete(wrapper);
      };
      listen(document, 'shopify:section:unload', (event) => { if (event.target === section) destroy(); });
      controllers.set(wrapper, destroy);
      schedule();
    });
  };
  window.glgsNavigationGeometry = { init };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
